import styled, {css} from 'styled-components';

import {colors} from 'theme';

export const Wrapper = styled.div`
    max-width: 1800px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    row-gap: 30px;
    background: ${colors.lightGrey};
`;

export const Container = styled.div`
    background: ${colors.white};
    width: 100%;
    padding: 24px;
    border-radius: 16px;
`;

export const GapedRow = styled.div`
    display: flex;
    gap: 100px;

    & > * {
        flex: 1;
        width: 100%;
    }
`;

export const Row = styled.div`
    display: flex;
    border-radius: 16px;
    width: 100%;
    background: ${colors.white};
`;

export const Divider = styled.div`
    width: 1px;
    background: #e2e2e2;
    margin: 40px 20px;
`;

export const Title = styled.h2<{vertical?: boolean}>`
    display: flex;
    flex-direction: ${({vertical}) => (vertical ? 'column' : 'row')};
    gap: ${({vertical}) => (vertical ? '20px' : '40px')};
    ${({vertical}) =>
        !vertical &&
        css`
            align-items: center;
        `};
    font-size: 42px;
    margin: 0;

    & > span {
        font-size: 28px;
        font-weight: 400;
        line-height: 22px;
    }
`;

export const Header = styled.h2`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 28px;
    font-weight: 600;
    color: ${colors.darkGrey};
    margin: 0 0 20px;

    & > span {
        &:nth-child(2) {
            font-size: 28px;
        }
    }
`;

export const Summary = styled.div`
    display: flex;
    gap: 40px;

    & > span {
        font-size: 28px;

        &:first-child {
            font-weight: 400;
        }

        &:last-child {
            font-weight: 600;
        }
    }
`;

export const Label = styled.span`
    font-size: 20px;
    font-weight: 600;
    color: #5658d8;
`;

export const List = styled.div<{summary?: boolean}>`
    display: flex;
    flex-direction: column;
    gap: 12px;

    & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > * {
            width: 50%;
        }

        & > span {
            font-size: 18px;
            color: #8a8a8a;

            &:nth-child(2) {
                color: ${colors.darkGrey};
                font-weight: ${(p) => (p.summary ? '600' : '400')};
                ${(p) =>
                    p.summary &&
                    css`
                        width: 160px;
                    `}
            }

            &:nth-child(3) {
                color: ${colors.darkGrey};
                width: fit-content;
                font-weight: 600;
            }
        }
    }
`;

export const Cell = styled.div`
    font-size: 14px;
`;

export const ChargesCell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;

    & > h4 {
        color: #5658d8;
        font-size: 12px;
        font-weight: 600;
        margin: 0;
    }

    & > div:first-of-type {
        display: flex;
        flex-direction: column;

        & > span {
            font-size: 14px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;

            &:first-child {
                color: ${colors.textSecondary};
            }
        }
    }

    & > div:last-of-type {
        display: flex;
        gap: 4px;
        justify-content: space-between;

        & > div {
            display: flex;
            flex-direction: column;

            & > span {
                font-size: 14px;
                color: ${colors.textSecondary};

                &:last-child {
                    color: ${colors.darkGrey};
                }
            }
        }
    }
`;

export const BlockQR = styled.div`
    display: flex;
    gap: 46px;
    align-items: center;
    justify-content: center;
    height: 100%;
    max-height: 140px;

    & > img {
        height: 100%;
    }

    & > span {
        color: #8a8a8a;
        font-size: 20px;
    }
`;
